exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".AvatarVcDemo h4[data-v-a6c8b64c]{color:#066}.AvatarVcDemo .demoItem[data-v-a6c8b64c]{padding:5px 0;font-size:18px;border-bottom:1px dotted #999}.AvatarVcDemo .demoItem .item[data-v-a6c8b64c]{margin-right:15px}.AvatarVcDemo .demoItem .badgeItem[data-v-a6c8b64c]{width:16px;height:16px}.AvatarVcDemo .demoItem .badgeItem2[data-v-a6c8b64c]{width:10px;height:10px}", ""]);

// exports
